import Modal from "react-modal";
import { Customer } from "../../../types";
import { useState } from "react";
import { ModalTypes, useModal } from "../../../app/modalProvider/ModalProvider";
import {
  CloseButton,
  HeaderWrapper,
  ModalContentWrapper,
  Title,
} from "../Modal.Styles";
import AccountAddForm from "../../forms/account/AccountAddForm";
import ModalChangesAlertDialog from "../../dialogs/ModalChangesAlert";
import ProductEditForm from "../../forms/systemSettings/ProductEditForm";
import { api } from "../../../api/ApiSlice";
import Loader from "../../misc/Loader";

//Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "1000px",
    height: "750px",
    width: "calc(100vw - 50px)",
    overflow: "auto",
    padding: "0",
  },
  overlay: {
    backdropFilter: "none",
    zIndex: 1000,
  },
};

interface Props {
  id: string;
}

const ProductEditModal = ({ id }: Props) => {
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [changed, setChanged] = useState<boolean>(false);

  const productData = api.useGetProductQuery(id);
  console.log(productData.data);
  const { closeModal } = useModal();

  const handleCloseModal = () => {
    if (changed) {
      setShowAlert(true);
    } else {
      closeModal(ModalTypes.EDIT_PRODUCT_MODAL);
    }
  };
  const handleCloseModalOnSuccess = () => {
    setChanged(false);
    closeModal(ModalTypes.EDIT_PRODUCT_MODAL);
  };
  const handleExitFormUnsavedChanges = () => {
    closeModal(ModalTypes.EDIT_PRODUCT_MODAL);
  };
  return (
    <>
      <Modal
        isOpen
        style={customStyles}
        shouldCloseOnOverlayClick={false}
        onRequestClose={handleCloseModal}
      >
        <ModalContentWrapper>
          <HeaderWrapper>
            <Title>Rediger produkt </Title>
            <CloseButton onClick={handleCloseModal}></CloseButton>
          </HeaderWrapper>
          {productData.isLoading && <Loader />}
          {productData.isSuccess && (
            <ProductEditForm
              product={productData.data}
              setChanged={setChanged}
              handleCloseModal={handleCloseModal}
              handleCloseModalOnSuccess={handleCloseModalOnSuccess}
            />
          )}
        </ModalContentWrapper>
      </Modal>
      {showAlert && (
        <ModalChangesAlertDialog
          showAlert={showAlert}
          setShowAlert={setShowAlert}
          handleExitFormUnsavedChanges={handleExitFormUnsavedChanges}
        />
      )}
    </>
  );
};
export default ProductEditModal;
